"use client";
import React from "react";
import logo from "@/assets/footer/Autoeinfachlos_logo_weiss.webp";
import facebook from "@/assets/svgs/facebook.svg";
import instagram from "@/assets/svgs/instagram.svg";
// import twitter from "@/assets/svgs/twitter.svg";
import linkedin from "@/assets/svgs/linkedin.svg";
import Image from "next/image";
import "./Footer.css";
import Button from "@/common/Button";
import Link from "next/link";
import { usePathname } from "next/navigation";

function Footer({ patternStrings }) {
  const pathname = usePathname();

  /* 1 ▪ hide on the routes you passed in */
  const hideByRoute = patternStrings.withoutFooter
    .map((s) => new RegExp(s, "i"))
    .some((rx) => rx.test(pathname));

  /* 2 ▪ keep existing early-exits */
  if (hideByRoute) return null;

  return (
    <div className="Footer">
      <div className="Footer-wrapper">
        <Image src={logo} className="Footer-logo" alt="logo" />

        <div className="Footer-socials-wrapper">
          <a
            href="https://www.facebook.com/Autoeinfachlos"
            target="_blank"
            rel="noopener noreferrer"
            className="Footer-social"
          >
            <Image
              src={facebook}
              alt="facebook"
              className="Footer-socials-image"
            />
          </a>

          <a
            href="https://www.instagram.com/autoeinfachlos/"
            target="_blank"
            rel="noopener noreferrer"
            className="Footer-social"
          >
            <Image
              src={instagram}
              alt="instagram"
              className="Footer-socials-image"
            />
          </a>

          {/* <div className="Footer-social">
            <Image
              src={twitter}
              alt="twitter"
              className="Footer-socials-image"
            />
          </div> */}

          <a
            href="https://www.linkedin.com/company/autoeinachlos/"
            target="_blank"
            rel="noopener noreferrer"
            className="Footer-social"
          >
            <Image
              src={linkedin}
              alt="linkedin"
              className="Footer-socials-image"
            />
          </a>
        </div>
        <Button
          isSecondary
          maxWidth="300px"
          link="https://www.autoeinfachlos.at/"
          targetBlank={true}
        >
          Autoeinfachlos für Kunden
        </Button>

        <ul className="footer-end-list">
          <li className="footer-end-list-item transition">
            <Link href="/kontaktiere-uns">Kontakt</Link>
          </li>
          <li className="footer-end-list-item transition">
            <Link href="/agb">AGB</Link>
          </li>
          <li className="footer-end-list-item transition">
            <Link href="/impressum">Impressum</Link>
          </li>
          <li className="footer-end-list-item transition">
            <Link href="/datenschutz">Datenschutz</Link>
          </li>
        </ul>

        <div className="Footer-bottom-text">
          <span>© Web3 DevOps GmbH</span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
